export default __webpack_public_path__ + "static/media/icon-up.81c49f73.svg";